import styled, { css } from "styled-components";
import getColor from "../../../utils/getColor";
import space from "../../../utils/space";
import AbsoluteContainerOrg from "../../organisms/AbsoluteContainerOrg";
import TextareaMol from "../TextareaMol";
var textAreaSafeSpaceForContainer = 7;
export var StyledTextareaMol = styled(TextareaMol).withConfig({
  componentId: "sc-k3gqov-0"
})(["padding-bottom:", ";"], space(textAreaSafeSpaceForContainer));
export var StyledAbsoluteContainerOrg = styled(AbsoluteContainerOrg).withConfig({
  componentId: "sc-k3gqov-1"
})(function (_ref) {
  var theme = _ref.theme,
    $backgroundColor = _ref.$backgroundColor;
  return css(["background-color:", ";"], getColor(theme, $backgroundColor));
});